import { render, staticRenderFns } from "./TableBlock.vue?vue&type=template&id=26fc6744&"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/saas-tool/client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26fc6744')) {
      api.createRecord('26fc6744', component.options)
    } else {
      api.reload('26fc6744', component.options)
    }
    module.hot.accept("./TableBlock.vue?vue&type=template&id=26fc6744&", function () {
      api.rerender('26fc6744', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/wiki/TableBlock.vue"
export default component.exports